import { configureStore } from '@reduxjs/toolkit';
import { Store } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import thunkMiddleware from 'redux-thunk';

import { FhhState } from '@/interfaces';
import { isDebugMode } from '@/constants';
import { reducer } from './reducer';

const makeStore = () =>
    configureStore({
        reducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunkMiddleware),
    });

export const wrapper = createWrapper<Store<FhhState>>(makeStore, { debug: isDebugMode });
